"use client";
import {
  useModalHeader
} from "./chunk-YTAMFT7T.mjs";
import {
  forwardRef
} from "./chunk-TKNQSGPN.mjs";

// src/modal-header.tsx
import { useEffect } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var ModalHeader = forwardRef((props, ref) => {
  const {
    Component,
    icon,
    description,
    children,
    setHeaderMounted,
    getHeaderProps,
    getHeaderIconProps,
    getHeaderTitleProps,
    getHeaderDescriptionProps
  } = useModalHeader(props);
  useEffect(() => {
    setHeaderMounted(true);
    return () => setHeaderMounted(false);
  }, [setHeaderMounted]);
  return /* @__PURE__ */ jsxs(Component, { ...getHeaderProps(), children: [
    icon && /* @__PURE__ */ jsx("span", { ...getHeaderIconProps(), children: icon }),
    /* @__PURE__ */ jsxs("div", { ...getHeaderTitleProps(), children: [
      children,
      description && /* @__PURE__ */ jsx("p", { ...getHeaderDescriptionProps(), children: description })
    ] })
  ] });
});
ModalHeader.displayName = "UI.ModalHeader";
var modal_header_default = ModalHeader;

export {
  modal_header_default
};
